module.exports = __webpack_public_path__ + "img/icon_payment.8dd282cf.png";